import { MenuList } from '@mui/material';
import moment from 'moment-timezone';
import React, { FC } from 'react';

import { ListItemText, MenuItem } from '@sumologic/yama-ds-components';

import { DISPLAY_FORMAT } from 'shared/utils/date';

import {
  RecordSearchDateRangeRelativeValue,
  RecordSearchDateRangeValue,
} from './types';

export type RelativeValueOptions = Array<{
  value: RecordSearchDateRangeRelativeValue;
  label: string;
}>;

export const relativeValueOptions: RelativeValueOptions = [
  { value: '15m', label: 'Last 15 Minutes' },
  { value: '60m', label: 'Last 60 Minutes' },
  { value: '3h', label: 'Last 3 Hours' },
  { value: '12h', label: 'Last 12 Hours' },
  { value: '24h', label: 'Last 24 Hours' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: '3d', label: 'Last 3 Days' },
  { value: '7d', label: 'Last 7 Days' },
  { value: 'thisweek', label: 'This Week' },
  { value: 'prevweek', label: 'Previous Week' },
  { value: '14d', label: 'Last 14 Days' },
  { value: '30d', label: 'Last 30 Days' },
  { value: 'thismonth', label: 'This Month' },
  { value: 'prevmonth', label: 'Previous Month' },
];

export const labelForValue = (
  value: RecordSearchDateRangeValue,
  relativeOptions = relativeValueOptions
) => {
  if (typeof value === 'string') {
    return relativeOptions.find((o) => o.value === value)!.label;
  } else {
    return value.map((date) => moment(date).format(DISPLAY_FORMAT)).join(' - ');
  }
};

interface RecordsSearchRelativeTimeSelectProps {
  relativeOptions?: RelativeValueOptions;
  selectedValue: RecordSearchDateRangeValue;
  onDeactivate: () => void;
  onSelectValue: (value: RecordSearchDateRangeValue) => void;
}

export const RecordsSearchRelativeTimeSelect: FC<
  React.PropsWithChildren<RecordsSearchRelativeTimeSelectProps>
> = ({
  relativeOptions = relativeValueOptions,
  selectedValue,
  onDeactivate,
  onSelectValue,
}) => (
  <MenuList>
    {relativeOptions.map(({ value, label }) => (
      <MenuItem
        data-sumo-test={`relative-time-${label.replace(/\s/g, '-')}`}
        key={value}
        onClick={() => {
          onDeactivate();
          onSelectValue(value);
        }}
        selected={value === selectedValue}
      >
        <ListItemText primary={label} />
      </MenuItem>
    ))}
  </MenuList>
);
